module.exports = __webpack_public_path__ + "img/team_pic3.85055179.jpg";